import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import { PromoGroup } from 'interfaces/api/promoGroups.interfaces'
import {
  CreatePromoGroupParams,
  RemovePromoGroupParams,
  UpdatePromoGroupParams,
} from 'interfaces/store/promoGroups.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'

export const getAllPromoGroups = createAsyncThunk('promoGroups/getAllPromoGroups', async (_, { rejectWithValue }) =>
  api.promoGroups.getAll().catch((error) => rejectWithValue(error.message)),
)

export const setPromoGroupValidationErrors = createAction<ValidationErrorsApi | null>(
  'promoGroups/setPromoGroupValidationErrors',
)

export const createPromoGroup = createAsyncThunk(
  'promoGroups/createPromoGroup',
  async (params: CreatePromoGroupParams, { rejectWithValue, dispatch }) =>
    api.promoGroups
      .create(params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setPromoGroupValidationErrors(null))
        toast.success(Success.PromoGroupCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setPromoGroupValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updatePromoGroup = createAsyncThunk(
  'promoGroups/updatePromoGroup',
  async (params: UpdatePromoGroupParams, { rejectWithValue, dispatch }) =>
    api.promoGroups
      .update(params.id, params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setPromoGroupValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setPromoGroupValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removePromoGroup = createAsyncThunk(
  'promoSettings/removePromoGroup',
  async (params: RemovePromoGroupParams, { rejectWithValue }) =>
    api.promoGroups
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.PromoGroupRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)

export const setSinglePromoGroup = createAction<PromoGroup | null>('promoGroups/setSinglePromoGroup')
